import { Foundation } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";

import ContingentsSortTabsTpl from "../../templates/contingents/ContingentsSortTabsTpl.html";

export default InboomaBaseView.extend({
  template: ContingentsSortTabsTpl,
  el: "#inb-c-main-sort-nav",

  events: {
    "click .tabs-title": "_onClickChangeSort",
  },

  initialize() {
    this.render();
  },

  _onClickChangeSort(ev) {
    const el = ev.currentTarget;

    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active"),
      newDirection = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      this.collection.setSort(sortKey, newDirection);

      const activeSortTab = this.$el[0].querySelector(".is-active");

      // @todo remove/set aria-selected attribute
      activeSortTab.classList.remove("is-active");
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }

    return false;
  },

  onRender() {
    // https://foundation.zurb.com/sites/docs/sticky.html
    Foundation.Sticky.defaults.marginTop = 0;
    const meSoSticky = new Foundation.Sticky(this.$el);
  },
});
